import React, { PropsWithChildren } from 'react';
import { Icon } from '../../icons/Icon';
import { IconNames } from '../../icons/Icons';
import styles from './PhotoEditButtonGroup.module.scss';

export const PhotoEditButtonGroup = ({ children }: Props) => {
    if (React.Children.count(children) > 0) {
        return (
            <div className={styles.buttonGroup}>
                {children}
            </div>
        );
    } else {
        return null;
    }
};

PhotoEditButtonGroup.Button = ({ children, onClick, icon, type = 'filter' }: ButtonProps) => {
    if (!icon) {
        return (
            <div className={styles.button} onClick={onClick}>
                {children}
            </div>
        );
    } else {
        return (
            <div className={styles.button} onClick={onClick}>
                {type === 'rotate' && <Icon size='large' type={icon} className={styles[type]} />}
                {children}
                {type === 'filter' && <Icon size='xlarge' type={icon} className={styles[type]} />}
            </div>
        );
    }
};

type ButtonProps = PropsWithChildren<{
    icon?: IconNames;
    onClick: () => void;
    type?: 'rotate' | 'filter';
}>;

type Props = PropsWithChildren<Record<never, never>>;